export const Jeddah = {
  themeName: "Jeddah",
  isDark: false,
  CardViewBgColor: "#0EAAC410",
  secondaryLight: "#2A256D80",
  primary: "#0EAAC4",
  iconAppItem: "#0EAAC4",
  AppText: "#2A256D",
  loginFooter: "#0EAAC4",
  connectBtn: "#0EAAC4",
  loader: "#0EAAC4",
  headerColor: "#0EAAC4",
  primaryLight: "#0EAAC450",
  primaryColor: "#0EAAC4B2",
  textColor: "#000",
  listBg: "#ffffff",
  containerLanguageIcon: "#ffffff",

  separatorColor: "#aaa",

  danger: "#EE6E6E",
  warning: "#e59d4b",
  secondary: "#2A256D",

  settingCollapseColor: "#eee",
  welcomeBg: "#F1FAFC",
  success: "#3ecd7e",
  primaryDark: "#061933",
  offline: "#ec4545",
  offlineLabel: "#838383",
  labelColor: "#2A256D",
  playerControl: "#FFFFFF30",
  whiteToast: "#FFF",
  loginText: "#FFF",
  blazeOrangeToast: "#FE6301",
  mantisToast: "#69C779",
  altoToast: "#D8D8D8",
  dustyGrayToast: "#979797",
  infoToast: "#0EAAC4",
  yellowToast: "#edc300",
  greyToast: "#ccc",
  grayToast: "#aaa",
  lightToast: "#CDE6FC",
  appBg: "#f8f8f8",
  appBorder: "#e7e7e7",
  label: "#0EAAC4",
  groupIcon: "#ffffff",

  borderRecord: "#0EAAC450",
  borderFormInput: "#eee",
  SelectedDrawerItem: "#CDE6FC",
  swipableBg: "#ffffff",
  landingScreenModeBg: "#F3F3F3",
  calenderBorder: "#CDE6FC",
  cancelButton: "#eee",
  listPlaceHolder: "#eee",
  fapMap: "#aaa",
  fapMapBg: "#ffffff",
  fapMapActive: "#0EAAC4",
  listBgCard: "#eee",
  noItemToDisplay: "#ccc",
  listItem: "#ffff",
  linkColor: "#1D9BF0",
  bgLoginInput: "#FFFFFF8A",

  colorTextInput: "#2A256D",
  LogincolorTextInput: "#000",
  LogincolorLabelInput: "#888",
  loginOptions: "#000",
  shadowBtnConnect: "#2A256D",
  bnConnect: "#0EAAC4",
  notFocusedLabelInput: "#0EAAC4",
  focusedLabelLoginInput: "#303284",
  resetInputLogin: "#0EAAC4",
  resetInputLogin: "#303284",

  languageIcon: "#0EAAC4",
  loginText: "#333",
  loginBtnLabel: "#fff",
  notfocusedBorderLoginInput: "#ffffff",
  headerPrimary: "#0EAAC400",
  headerDark: "#06193300",
  headerText: "#2A256D",
  notificationUpColor: "#F5FDFE",
  notificationDownColor: "#E7FAFD",

  listItemNotificationUpColor: "#F1FCFE",
  listItemNotificationDownColor: "#DEF8FD",

  listItemOfflineUpColor: "#FFFFFF",
  listItemOfflineDownColor: "#F1F3F4",

  notFocusedSocialMedia: "#0EAAC4",
  focusedSocialMedia: "#0EAAC4cc",
  loginBgFooter: "#fff",
  
  //Costum4
  loginFirstTabTitle:"#222",
  loginTabTitle:"#222",
  loginTabSelected:"#fff",
  loginTabNotSelected:"#ffffff4d",

  //Custom Languge Modal
  languageContainerLeft:"#fff",
  languageContainerRight:"#0EAAC4",
  submitLeftConnect:"#222",
  submitRightConnect:"#fff",

};
